import { IconButton, Stack, Tooltip } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import CopyToClipboard from '../../../CopyToClipboard';
import { KVRow, Label, Value } from './styled';
import { FieldRowProps } from './types';

const FieldRow = ({ field, isPinned, showPinControl = false, togglePin }: FieldRowProps) => {
  return (
    <KVRow key={field.key} isGridLayout={!!field.label}>
      {field?.label ? (
        <Label variant="body2" color="text.secondary">
          {field.label}
        </Label>
      ) : null}

      {field?.customValue ? (
        field.customValue
      ) : (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0, width: '100%' }}>
          <CopyToClipboard
            label={field.copyLabel ?? field.label ?? ''}
            onCopy={field?.onCopyToClipboard}
            tooltipTitle={field.tooltipTitle}
            value={field.copyText ?? field.value ?? ''}
          >
            <Value variant="body2" sx={field.valueSx}>
              {field.value ?? '—'}
            </Value>
          </CopyToClipboard>

          {showPinControl && !field?.pinnedByDefault ? (
            <Tooltip title={isPinned(field.key) ? 'Unpin' : 'Pin'}>
              <IconButton size="small" onClick={() => togglePin(field.key)}>
                {isPinned(field.key) ? <PushPinIcon fontSize="small" /> : <PushPinOutlinedIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
          ) : null}
        </Stack>
      )}
    </KVRow>
  );
};

export default FieldRow;
